<script setup lang="ts">
import { toRefs } from 'vue';
import { DialogModal } from '@common';
import type { HeightmapSaveWarningModalProps } from '../config';
import { useHeightmapSaveWarningModal } from '../composables/heightmap-save-warning-modal.composable';
import { HtmlContentContainer } from '@shared';

const props = defineProps<HeightmapSaveWarningModalProps>();
const { config } = toRefs(props);

const { onConfirm, onCancel, partiallyCoveredParcels, uncoveredParcels, infoHtmlBlockconfig } =
  useHeightmapSaveWarningModal(config.value);
</script>

<template>
  <dialog-modal
    :config="config"
    class="parcel-group-modal">
    <template #title></template>
    <template #default>
      <div
        v-if="partiallyCoveredParcels"
        class="mb-2">
        <strong>{{ $t('heightmap.label.particialCoverageWarning') }}:</strong>
        <div>{{ partiallyCoveredParcels }}</div>
      </div>
      <div v-if="uncoveredParcels">
        <strong>{{ $t('heightmap.label.uncoverageWarning') }}:</strong>
        <div>{{ uncoveredParcels }}</div>
      </div>
      <html-content-container
        :config="infoHtmlBlockconfig"
        class="pt-3" />
    </template>
    <template #actions="{ close }">
      <div class="d-flex flex-grow-1 justify-space-between">
        <div class="mt-1">
          <v-btn
            variant="elevated"
            class="mx-2 px-3"
            color="primary"
            @click="onConfirm(close)">
            {{ $t('button.okay') }}
          </v-btn>
          <v-btn
            class="px-3 mr-3"
            color="error"
            @click="onCancel(close)">
            {{ $t('button.cancel') }}
          </v-btn>
        </div>
      </div>
    </template>
  </dialog-modal>
</template>
